import { Tabs } from "@shared/ui/tabs";
import { DisconnectionSettings } from "./disconnection/disconnection";
import { ReconnectionSettings } from "./reconnection/reconnection";
import { TransferSettings } from "./transfer/transfer";

export function OperationalSLASettings() {
  const tabComponents = {
    disconnection: {
      label: "Disconnection",
      shortLabel: "Disconnection",
     component: <DisconnectionSettings />,
    },
    reconnection: {
      label: "Reconnection",
      shortLabel: "Reconnection",
     component: <ReconnectionSettings />,
    },
    transfer: {
      label: "Transfer",
      shortLabel: "Transfer",
     component: <TransferSettings />,
    }
  };

  const urlMapping = {
    disconnection: "disconnection",
    reconnection: "reconnection",
    transfer: "transfer"
  };

  return (
    <div className="space-y-6">
      <Tabs
        defaultValue="disconnection"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-3 mb-6"
        idPrefix="operational-sla-sub-tab"
        className="w-full"
        level={1}
      />
    </div>
  );
}